<template>
    <div class="page-table-container">
        <el-table 
            :data="datas" 
            :row-key="rowkey" 
            @sort-change="sortChange" 
            @selection-change="selectionChange" 
            :tree-props="treeprops" 
            @row-click="handleRowClick"  
            @row-dblclick="handleRowDblClick" 
            @row-contextmenu="handleRowContextmenu" 
            :height="tableHeight" 
            stripe 
            class="page-table"
            :size="tablesize"
        >
            <slot />
        </el-table>
        
        <div v-if="showPagination" class="page-table-pagination">
            <el-pagination 
                :current-page="page" 
                :page-size="size" 
                :total="total" 
                @size-change="handleSizeChange" 
                @current-change="handlePageChange"  
                :page-sizes="pageSizes"
                layout="total, sizes, prev, pager, next, jumper"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "PageTable",
    props: {
        page: {
            type: Number,
            default: 1
        },
        size: {
            type: Number,
            default: 20
        },
        total: {
            type: Number,
            default: null
        },
        datas: {
            type: Array,
            default: () => []
        },
        rowkey: {
            type: String,
            default: ''
        },
        treeprops: {
            type: Object,
            default: () => ({})
        },
        tablesize: {
            type: String,
            default: ''
        },
        pageSizes: {
            type: Array,
            default: () => [5, 10, 15, 20, 30, 50, 100, 200, 300, 400]
        },
        autoHeight: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            tableHeight: 500
        }
    },
    computed: {
        showPagination() {
            return this.total !== null && this.total > 0;
        }
    },
    mounted() {
        this.updateTableHeight();
    },
    updated() {
        this.updateTableHeight();
    },
    methods: {
        updateTableHeight() {
            if (!this.autoHeight) return;
            
            this.$nextTick(() => {
                const containerHeight = this.$el.offsetHeight;
                this.tableHeight = this.showPagination ? containerHeight - 70 : containerHeight;
            });
        },
        
        selectionChange(selection) {
            this.$emit("selection-change", selection);
        },
        
        handleRowClick(row, column, event) {
            this.$emit("row-click", { row, column, event });
        },
        
        handleRowDblClick(row, column, event) {
            this.$emit("row-dbclick", { row, column, event });
        },
        
        handleRowContextmenu(row, column, event) {
            this.$emit("row-context", { row, column, event });
        },
        
        handleSizeChange(size) {
            this.$emit("change", this.page, size);
        },
        
        handlePageChange(page) {
            this.$emit("change", page, this.size);
        },
        
        sortChange(sortInfo) {
            this.$emit("sortChange", sortInfo);
        }
    }
}
</script>

<style lang="scss" scoped>
.page-table-container {
    height: 100%;
    width: 100%;
    padding: 20px;
    position: relative;
    box-sizing: border-box;
}

.page-table {
    width: 100%;
    border-radius: 5px;
    
    ::v-deep th {
        text-align: center;
        background-color: #e9f2ff !important;
        color: #55565a;
        font-weight: bold;
    }
}

.page-table-pagination {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 44px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 20px;
    box-sizing: border-box;
    
    .el-pagination {
        font-size: 14px;
    }
}
</style>